import { useEffect } from "react";

import {
  MotionGlobalConfig,
  animate,
  motion,
  useMotionValue,
  useReducedMotionConfig,
  useTransform,
} from "framer-motion";

const EASE_OUT = [0.22, 1, 0.36, 1] as const;

/** Panel sonlari ajratgichsiz chiqadi — `StatTile` ilgari ham shunday chizardi. */
const plain = (value: number): string => String(Math.round(value));

interface AnimatedNumberProps {
  value: number;
  format?: (value: number) => string;
  className?: string;
}

/**
 * Qiymatga sanab ko'tariladigan son.
 *
 * Har kadrda React qayta chizilmaydi: son `MotionValue` orqali to'g'ridan-
 * to'g'ri matnga yoziladi. "Harakatni kamaytirish" yoqilgan bo'lsa yoki
 * animatsiyalar o'chirilgan bo'lsa (testlar), son darhol oxirgi qiymatda
 * chiziladi — oraliq raqamlar hech qachon ko'rinmaydi.
 */
export const AnimatedNumber = ({ value, format = plain, className }: AnimatedNumberProps) => {
  const reduced = useReducedMotionConfig();
  const still = reduced === true || MotionGlobalConfig.skipAnimations === true;

  const count = useMotionValue(still ? value : 0);
  const text = useTransform(count, latest => format(latest));

  useEffect(() => {
    if (still) {
      count.set(value);
      return;
    }
    const controls = animate(count, value, { duration: 0.9, ease: EASE_OUT });
    return () => controls.stop();
  }, [count, value, still]);

  if (still) return <span className={className}>{format(value)}</span>;

  return <motion.span className={className}>{text}</motion.span>;
};
